import React from 'react';
import {Counts} from '../jobs.fetch';
import {withLocalization} from '@epic-core/localization';
import {Filters} from '../JobsView.styles';
import {MobileFilterHeading} from '../mobile/MobileFilterHeading';
import {SearchStandard, JobSearchProps} from '../search/SearchStandard';
import {LocationDropdown} from './LocationDropdown';
import {RemoteEligible} from './RemoteEligible';
import {StandardDropdowns} from './StandardDropdowns';
import {useBreakpointDown} from 'epic-ue-theme';
import {CustomDropdown, CheckboxMenuItem} from 'epic-ue-ui';
import {JobFilters} from '../jobs.callbacks';
import {stopFocusOnClick} from 'epic-ue-shared';
import {JobsColumnProps} from '../JobsView';

interface Props {
    getMessage: (key: string) => string;
    hidden?: boolean;
    toggleCheckboxFilter: (e: any, filterName: string, value: string) => void;
    setLocationFilter: (e: any, filterName: string, value: string) => void;
    jobsFilters: JobFilters;
    counts?: Counts;
    openedFilterBarMobile?: boolean;
    setOpenedFilterBarMobile: (n: boolean) => void;
    setJobResultsPage: (n: number) => void;
    filterLabel?: string;
    productLabel?: string;
    typeLabel?: string;
    remoteLabel?: string;
    columnLabels?: JobsColumnProps;
    searchLabel?: string;
    hideRemoteFilter?: boolean;
}

const JobsViewFiltersComponent = ({
    getMessage,
    hidden,
    openedFilterBarMobile,
    setOpenedFilterBarMobile,
    counts,
    jobsFilters,
    search,
    setSearch,
    setJobResultsPage,
    toggleCheckboxFilter,
    setLocationFilter,
    filterLabel,
    productLabel,
    typeLabel,
    remoteLabel,
    columnLabels,
    searchLabel,
    hideRemoteFilter
}: Props & JobSearchProps): JSX.Element | null => {
    const isSm = useBreakpointDown('sm');

    if (hidden) return null;

    return (
        <Filters className={`${openedFilterBarMobile ? 'opened-mobile' : ''} `}>
            <div className={`filters-bar ${openedFilterBarMobile ? 'opened-mobile' : ''} `}>
                {isSm && (
                    <MobileFilterHeading
                        setOpenedFilterBarMobile={setOpenedFilterBarMobile}
                        filterLabel={filterLabel}
                    />
                )}

                <CustomDropdown
                    label={columnLabels?.department || getMessage('epic.jobs.column.department')}
                    hasCheckedItems={jobsFilters['department'] !== undefined}>
                    {counts?.department &&
                        Object.keys(counts?.department)
                            .sort()
                            .map((keyName, i) => {
                                const checked =
                                    (jobsFilters['department'] &&
                                        jobsFilters['department'].includes(keyName)) ||
                                    false;
                                let disabled = false;
                                if (counts?.department?.[keyName] === 0) {
                                    disabled = true;
                                }

                                const filterItemLabel = `${keyName} (${counts?.department[keyName]}) `;
                                const filterItemLabelIsLong = filterItemLabel.length >= 40;

                                return (
                                    !disabled && (
                                        <CheckboxMenuItem
                                            key={i}
                                            checkboxProps={{
                                                checked,
                                                disabled
                                            }}
                                            className={
                                                isSm && filterItemLabelIsLong
                                                    ? 'reduce-font-size'
                                                    : ''
                                            }
                                            onMouseDown={stopFocusOnClick}
                                            onClick={(e) =>
                                                toggleCheckboxFilter(e, 'department', keyName)
                                            }>
                                            {filterItemLabel}{' '}
                                        </CheckboxMenuItem>
                                    )
                                );
                            })}
                </CustomDropdown>

                <LocationDropdown
                    jobsFilters={jobsFilters}
                    counts={counts}
                    setLocationFilter={setLocationFilter}
                    locationLabel={columnLabels?.location || getMessage('epic.jobs.column.location')}
                />
                <StandardDropdowns
                    jobsFilters={jobsFilters}
                    counts={counts}
                    toggleCheckboxFilter={toggleCheckboxFilter}
                    productLabel={productLabel}
                    companyLabel={columnLabels?.company || getMessage('epic.jobs.column.company')}
                    typeLabel={typeLabel}
                />
                {!hideRemoteFilter && (
                    <RemoteEligible
                        jobsFilters={jobsFilters}
                        counts={counts}
                        toggleCheckboxFilter={toggleCheckboxFilter}
                        remoteLabel={remoteLabel}
                    />
                )}

                {!isSm && (
                    <SearchStandard
                        search={search}
                        setSearch={setSearch}
                        searchLabel={searchLabel}
                        setJobResultsPage={setJobResultsPage}
                    />
                )}
            </div>
        </Filters>
    );
};

export const JobsViewFilters = withLocalization(JobsViewFiltersComponent);
